import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { ButtonProps } from '@mui/material/Button/Button';

type Props = ButtonProps & {
    toolTipTitle?: string,
    enableToolTip?: boolean,
};

const ActionButton = (props: Props) => {
    const {
        children,
        toolTipTitle,
        enableToolTip,
        ...buttonProps
    } = props;

    const buttonWithChild = (
        <Button
            {...buttonProps}
        >
            {children}
        </Button>
    );
    if (!enableToolTip) {
        return buttonWithChild;
    }
    return (

        <Tooltip
            title={toolTipTitle || 'Click'}
        >
            <span>
                {buttonWithChild}
            </span>
        </Tooltip>

    );
};

ActionButton.defaultProps = {
    toolTipTitle: '',
    enableToolTip: false,
};

export default ActionButton;
